import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { useFormContext } from "react-hook-form";
import {
  EventApplicationService,
  GlobalSettingService,
  PaymentService,
} from "../../../../services";
import {
  formatAmount,
  formatDateENGB,
  handleConsoleError,
} from "../../../../utils/common-methods";
import { globalConstant } from "../../../../constants/globalConstant";
import { toast } from "react-toastify";
//import { CaterApplicationFormModel } from "../../../../components/Model/CaterApplicationFormModel";

const LitterBond = ({ props }) => {
  //  const loginUser = AuthService.getLoginUser();
  const [paymentData, setPaymentData] = useState([]);
  // const [applicationFees, setApplicationFees] = useState();
  //  const [buyerFee, setBuyerFee] = useState();
  //  const [processingFee, setProcessingFee] = useState();
  //const [vatPercent, setVatPercent] = useState(0);
  //  const [vatNumber, setVatNumber] = useState("");

  //  const [amount, setAmount] = useState();
  const [litterBondAmount, setLitterBondAmount] = useState();

  const {
    getValues,
    // register,
    setValue,
  } = useFormContext();
  const eventApplicationCatersId = getValues("caterApplicationFormData.id");
  const dueDuePaymentDate = getValues("caterApplicationFormData.payOutDate");

  const initialPaymentPer = getValues(
    "caterApplicationFormData.initialPaymentPer"
  );

  const getLinkAccount = async () => {
    try {
      const res = await PaymentService.getConnectedAccountByEventId(
        getValues("caterApplicationFormData.eventId")
      );
      if (res?.isSuccess) {
        setValue("payment.connectedAccountId", res?.data?.stripeAccountId);
      }
    } catch (error) {
      // setIsProfileAvailable(false);
      props.application.setLoading(false);
     const message= handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };

  const getPaymentData = async () => {
    try {
      let isEoVatRegister = false;
      let isPlatformVatRegister = true;
      let vatPercent = 0;
      const response = await GlobalSettingService.getGlobalSettingList();

      if (response?.isSuccess && response?.data?.length > 0) {
        const vat = response?.data?.find(
          (item) => item.keyName.trim() === globalConstant.VAT_PERCENT.trim()
        );
        if (vat) {
          vatPercent = vat.keyValue;
        }
      }

      const res = await EventApplicationService.getCaterApplicationPaymentById(
        eventApplicationCatersId
      );
      if (res?.isSuccess && res?.data?.length > 0) {
        setPaymentData(res?.data);
        //Total Payable
        let applicationFee = res?.data?.find((s) =>
          s.name.toLowerCase().includes("Application Fee".toLowerCase())
        );
        if (applicationFee) {
          //  setApplicationFees(applicationFee?.total);
          if (applicationFee?.vat > 0) {
            isEoVatRegister = true;
          }
          if (isEoVatRegister === true && isPlatformVatRegister === false) {
            const vatApp = applicationFee?.vat;
            //vatAmount = vatAmount + vatApp;
            setValue("payment.applicationFee", applicationFee.total - vatApp);
          } else if (
            isPlatformVatRegister === true &&
            isEoVatRegister === false
          ) {
            const vatApp = (applicationFee?.total * vatPercent) / 100;
            // vatAmount = vatAmount + vatApp;
            setValue("payment.applicationFee", applicationFee.total + vatApp);
          } else {
            setValue("payment.applicationFee", applicationFee?.total);
          }
        }

        const buyerFee = res?.data.find((s) =>
          s.name.toLowerCase().includes("Buyer Fee (".toLowerCase())
        );
        if (buyerFee) {
          // setBuyerFee(buyerFee?.total);
          if (isEoVatRegister === true && isPlatformVatRegister === false) {
            const vatBuyer = buyerFee?.vat;
            // vatAmount = vatAmount + vatBuyer;
            setValue("payment.buyerFee", buyerFee?.total - vatBuyer);
          } else if (
            isEoVatRegister === false &&
            isPlatformVatRegister === true
          ) {
            const vatBuyer = (buyerFee?.total * vatPercent) / 100;
            // vatAmount = vatAmount + vatBuyer;
            setValue("payment.buyerFee", buyerFee?.total + vatBuyer);
          } else {
            setValue("payment.buyerFee", buyerFee?.total);
          }
        }

        const processingFee = res?.data.find((s) =>
          s.name.toLowerCase().includes("Processing Fees (".toLowerCase())
        );
        if (processingFee) {
          //setProcessingFee(processingFee?.total);
          setValue("payment.processingFee", processingFee?.total);
        }

        const totalPayable = res?.data.find((s) =>
          s.name.toLowerCase().includes("Total Payable".toLowerCase())
        ); // === "Total Payable");

        if (totalPayable) {
          let partAmount =
            totalPayable?.total * ((initialPaymentPer ?? 0) / 100);

          //  setAmount(partAmount);
          setValue("payment.amount", roundDown(partAmount, 2));
          setValue("payment.remainingAmount", totalPayable?.total - partAmount);
          setValue("payment.initialPaymentPer", initialPaymentPer);
        }
        const litterBond = res?.data.find((s) =>
          s.name.toLowerCase().includes("Refundable Litterbond".toLowerCase())
        ); // === "Total Payable");

        if (litterBond) {
          setLitterBondAmount(litterBond?.total);
        }
      }
    } catch (error) {
      // setIsProfileAvailable(false);
      props.application.setLoading(false);
      const message=handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };

  const roundDown = (value, decimals) => {
    const factor = Math.pow(10, decimals);
    //return Math.floor(value * factor) / factor;
    return Math.floor((value +1e-10)* factor) / factor; //TODO calculation fix
  };

  useEffect(() => {
    const bootstrapAsync = async () => {
      props.application.setLoading(true);
      await getLinkAccount();
      await getPaymentData();
      props.application.setLoading(false);
    };
    bootstrapAsync();
  }, []);

  return (
    <React.Fragment>
      <div role="tabpanel" className="tab-pane" id="Submit">
        <h3>Litter bond & taking declaration</h3>
        <p className="mt-3"> </p>
        <p>
          We are operating a litter bond system that consists of a £
          {litterBondAmount} bond. It is your responsibility to ensure your
          pitch (and 10m surrounding) is cleared of all rubbish post the event
          break down. Your deposit will be refunded post the event and upon the
          trader managers approval.
        </p>
        <h3 className="mb-3">Payment details</h3>
        <p>
          Invoices will be issued to all successful applicants with VAT added(where applicable).
        </p>
        {initialPaymentPer < 100 && (
          <p>
            {initialPaymentPer}% payment (including electricity and any other
            charges) is due immediately with the remaining balance due on{" "}
            {formatDateENGB(dueDuePaymentDate)}.
          </p>
        )}
        {initialPaymentPer === 100 && (
          <p>
            {initialPaymentPer}% payment (including electricity and any other
            charges) is due immediately.
          </p>
        )}
        <p>
          Non-payment will result in the stall being reallocated and the loss of
          your deposit.
        </p>
        <section className="edit-form-table">
          <div className="container mt-3">
            <div className="table-responsive">
              {/* BACS		◻ */}
              {/* <Form.Group controlId="amount">
                <Form.Control
                  type="hidden"
                  {...register("payment.amount")}
                  defaultValue={amount}
                  // onChange={handleInputChange}
                />
              </Form.Group>
              <Form.Group controlId="remainingAmount">
                <Form.Control
                  type="hidden"
                  {...register("payment.remainingAmount")}
                  defaultValue={applicationFees}
                  //  onChange={handleInputChange}
                />
              </Form.Group>
              <Form.Group controlId="buyerFee">
                <Form.Control
                  type="hidden"
                  {...register("payment.buyerFee")}
                //  defaultValue={buyerFee}
                  //  onChange={handleInputChange}
                />
              </Form.Group>
              <Form.Group controlId="processingFee">
                <Form.Control
                  type="hidden"
                  {...register("payment.processingFee")}
                //  defaultValue={processingFee}
                  //  onChange={handleInputChange}
                />
              </Form.Group>
              <Form.Group controlId="initialPaymentPer">
                <Form.Control
                  type="hidden"
                  {...register("payment.initialPaymentPer")}
                 // defaultValue={applicationFees}
                  //  onChange={handleInputChange}
                />
              </Form.Group>
              <Form.Group controlId="applicationFee">
                <Form.Control
                  type="hidden"
                  {...register("payment.applicationFee")}
                 // defaultValue={applicationFees}
                  //  onChange={handleInputChange}
                />
              </Form.Group>
              <Form.Group controlId="connectedAccountId">
                <Form.Control
                  type="hidden"
                  {...register("payment.connectedAccountId")}
                //  defaultValue={applicationFees}
                  //  onChange={handleInputChange}
                />
              </Form.Group> */}
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>Item</th>
                    <th>Amount (£)</th>
                    <th>Vat (£)</th>
                    <th>Total (£)</th>
                  </tr>
                </thead>
                <tbody>
                  <React.Fragment>
                    {paymentData.map((item, idx) => {
                      return (
                        item.amount > 0 && (
                          <tr key={idx}>
                            <td>{item?.name}</td>
                            <td>£{formatAmount(item?.amount)}</td>
                            <td>£{formatAmount(item?.vat)}</td>
                            <td>£{formatAmount(item?.total)}</td>
                          </tr>
                        )
                      );
                    })}
                  </React.Fragment>
                </tbody>
              </Table>
            </div>
          </div>
        </section>
      </div>
    </React.Fragment>
  );
};

export default LitterBond;
